import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  getStoredLanguage,
  setStoredLanguage,
  createTranslator,
  isSupported,
} from '../i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => getStoredLanguage());

  const setLanguage = useCallback((lang) => {
    if (!isSupported(lang)) return;
    setLanguageState(lang);
    setStoredLanguage(lang);
  }, []);

  // <html lang> 동기화 — 접근성 및 검색엔진을 위해
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = language;
    }
  }, [language]);

  const value = useMemo(() => {
    const t = createTranslator(language);
    return {
      language,
      setLanguage,
      t,
      languages: SUPPORTED_LANGUAGES,
      defaultLanguage: DEFAULT_LANGUAGE,
    };
  }, [language, setLanguage]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}

// 편의용 훅: t 함수만 필요한 경우
export function useTranslation() {
  const { t, language, setLanguage, languages } = useLanguage();
  return { t, language, setLanguage, languages };
}

export default LanguageContext;
